<template>
<div class="user-objects">

  <page-header>
    <nav-inner :use-user-links="true"/>
  </page-header>

  <div class="page-container">

    <div v-if="this.$route.query.objectSubmitted" class="object-submitted">
      Ваш объект помещен в очередь на депонирование. Пожалуйста, подождите
      пока он будет проверен и опубликован в системе!
    </div>
    <router-link
      class="help-link help-link_pcr"
      :to="{ path: '/help/18'}"
      target="_blank">
      Подробнее о моих объектах в разделе Помощь
    </router-link>

    <user-tasks
      v-if="userId"
      :userId="userId"/>

    <objects-search
      nothingFoundText="Вы не депонировали ни одного объекта."/>

  </div>

  <page-footer/>

</div>
</template>

<script>
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import UserTasks from '../UserTasks';
import ObjectsSearch from './ObjectsSearch';

export default {

  components: { PageHeader, PageFooter, NavInner, UserTasks, ObjectsSearch },

  data() {
    return {
      afterAdd: false,
      userId: '',
    };
  },

  created() {
    this.userId = this.$store.getters['user/getUserId'];
    this.$route.query.authorId = this.userId;
  },

};
</script>

<style lang="scss" scoped>
.page-container {
  margin-bottom: 30px;
}
.object-submitted {
  padding: 40px 20px;
  margin: 30px 0;
  background: #242628;
  border-radius: 10px;
  text-align: center;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserObjects.vue